import axios from 'axios'

export const createProject = async (projectName) => {
  const url = process.env.REACT_APP_ADMIN_API + `/create/${projectName}`
  const response = await axios.get(url, {})
  return response.data
}
